import { render, staticRenderFns } from "./GalleryDetail.vue?vue&type=template&id=caa22766&scoped=true&"
import script from "./GalleryDetail.vue?vue&type=script&lang=js&"
export * from "./GalleryDetail.vue?vue&type=script&lang=js&"
import style0 from "./GalleryDetail.vue?vue&type=style&index=0&id=caa22766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa22766",
  null
  
)

export default component.exports